export const BW_VARIANT = { RSETH: "rsETH", AGETH: "agETH" } as const;
export type TBW_VARIANT = (typeof BW_VARIANT)[keyof typeof BW_VARIANT];

export type TChainSelection = {
  id: number;
  title: string;
};

export const ALL_STEPS = {
  WRAP: "Wrap",
  UNWRAP: "Unwrap",
  BRIDGE: "Bridge",
  BRIDGE_TO_ETH: "BridgeToEth",
  BRIDGE_FROM_ETH: "BridgeFromEth"
};
